// extracted by mini-css-extract-plugin
export default {"form":"Form_form_h6CEr","body":"Form_body_fqOa4","content":"Form_content_dMqRc"};